import { isDepartmentInterviewerUser } from './assignmentHelpers';

export const HEAD_ADMIN_ROLE = 'HEAD ADMIN';
export const ADMIN_ROLE = 'ADMIN';

export const ADMIN_MENU_TABS = ['app-review', 'messages'];
export const ADMIN_SETTINGS_TABS = ['profile'];
export const ADMIN_ALLOWED_TABS = [...ADMIN_MENU_TABS, ...ADMIN_SETTINGS_TABS];

export const HEAD_ADMIN_CONTROL_TABS = [
  'create-accounts',
  'interviewers',
  'onhold',
  'job-offer',
  'hired',
  'pooling',
  'passed-interview',
  'failed-interview',
  'application-retracted',
  'app-requirements-guard',
];

export const normalizeAdminRole = (role) => {
  const normalized = String(role || '').trim().toUpperCase().replace(/\s+/g, ' ');
  if (normalized === HEAD_ADMIN_ROLE) return HEAD_ADMIN_ROLE;
  if (normalized === ADMIN_ROLE) return ADMIN_ROLE;
  return normalized;
};

export const isHeadAdminUser = (user) => {
  const role = normalizeAdminRole(user?.role);
  const position = String(user?.position || '').trim().toUpperCase();
  return role === HEAD_ADMIN_ROLE || position === HEAD_ADMIN_ROLE;
};

export const isDepartmentAdminUser = (user) => {
  if (isHeadAdminUser(user)) return false;
  const role = normalizeAdminRole(user?.role);
  return role === ADMIN_ROLE || isDepartmentInterviewerUser(user);
};

/** Messages inbox: Head Admin and HR Department only. */
export const canAccessAdminMessages = (user) => {
  if (!user) return false;
  if (isHeadAdminUser(user)) return true;

  const position = String(user.position || '').trim().toUpperCase();
  const role = String(user.role || '').trim().toUpperCase();

  return (
    position.includes('HR')
    || role === 'HR'
    || role.includes('HR')
  );
};

/** Voice assessment scores — Head Admin and ADMIN role only (not HR/Ops/TL/Client interviewers). */
export const canViewAssessmentScores = (user) => {
  if (isHeadAdminUser(user)) return true;
  if (isDepartmentInterviewerUser(user)) return false;
  return normalizeAdminRole(user?.role) === ADMIN_ROLE;
};

export const isAllowedAdminTab = (tab, user) => {
  if (isHeadAdminUser(user)) return true;
  if (tab === 'messages' && !canAccessAdminMessages(user)) return false;
  return ADMIN_ALLOWED_TABS.includes(tab);
};

export const getAdminAccessLabel = (user, labels = {}) => {
  if (isHeadAdminUser(user)) return labels.headAdmin || HEAD_ADMIN_ROLE;
  return labels.admin || ADMIN_ROLE;
};
